export enum DocumentationErrorType {
  ACCOUNT_NUMBER = 'Account Number',
  ADDRESS_DESTINATION = 'Address: Destination',
  CARRIER_INSTRUCTIONS = 'Carrier Instructions',
  DIMENSIONS = 'Dimensions',
  INCOTERMS = 'Incoterms',
  LETTER_OF_CREDIT_STIPULATIONS = 'Letter of Credit Stipulations',
  ORIGINALS_REQUIRED = 'Originals Required',
  PAYMENT_TERMS = 'Payment Terms',
  PRODUCT_DESCRIPTIONS = 'Product Descriptions',
  SIGNATURES = 'Signatures',
  TEMPERATURE_CONDITIONS = 'Temperature Conditions',
  WEIGHTS = 'Weights',
  OTHER = 'Other',
}
